'use es6';

import PropTypes from 'prop-types';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
function FormLink({
  formName,
  formId,
  portalId
}) {
  const formHref = `/forms/${portalId}/editor/${formId}/edit/form`;
  return /*#__PURE__*/_jsx(UILink, {
    className: "is--text--demibold",
    href: formHref,
    target: "_blank",
    children: formName
  });
}
FormLink.displayName = 'FormLink';
FormLink.propTypes = {
  formId: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  portalId: PropTypes.number.isRequired
};
export default FormLink;